module.exports = __webpack_public_path__ + "img/icon-coupon.cf523c0f.png";